
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1920","height":"3033","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1920 0H0v2085h.073C6.5 2609.66 433.812 3033 960 3033c526.19 0 953.5-423.34 959.93-948h.07V0z","fill":"url(#paint0_radial_891_2839)"}}),_c('defs',[_c('radialGradient',{attrs:{"id":"paint0_radial_891_2839","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"rotate(65.093 -43.863 1063.281) scale(2499.16 4065.49)"}},[_c('stop',{attrs:{"stop-color":"#EC7714"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#DF3021"}})])])])
          )
        }
      }
    